import { Component, Input} from '@angular/core';
import { BarChartComponent } from "../../charts/bar-chart.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-platform-useage-card',
  standalone: true,
  imports: [BarChartComponent, CommonModule],
  templateUrl: './platform-useage-card.component.html',
  styleUrl: './platform-useage-card.component.scss'
})
export class PlatformUseageCardComponent {
      @Input() filter: boolean = false;
    
}
